(function (module) {
    module.directive('unique', ['Auth', function (Auth) {
        return {
            require: 'ngModel',
            scope: {
                unique: '='
            },
            link: function (scope, ele, attr, ctrl) {
                var field = scope.unique;
                ctrl.$asyncValidators.unique = function (value) {
                    return Auth.validateField(field, value);
                };
            }
        };
    }]);
}(angular.module('emarket.commons')));
